import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Area } from '../../core/constants/area';
import { AuthResponseCode } from '../constants/auth-response-code.enum';
import { RequestPasswordReset } from './models/request-password-reset.model';

@Injectable()
export class ForgotPasswordService {

  constructor(private httpClient: HttpClient) { }

  public async requestPasswordReset(model: RequestPasswordReset) {
    const url = `${environment.dotNetApiUrl}/${Area.auth}/ForgotPassword`;
    return this.httpClient.post<AuthResponseCode>(url, model).toPromise();
  }

  public async submitPasswordReset(model) {
    const url = `${environment.dotNetApiUrl}/${Area.auth}/ResetPassword`;
    return this.httpClient.post<void>(url, model).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/forgot-password.service.ts